window.chmContextMenu = (function () {
    let STATUS;

    STATUS = {
        isInitialized: false
    };

    return {
        hide: function () {
            let menus;

            menus = document.querySelectorAll('.chmContextMenu');

            menus.forEach(menu => {
                menu.classList.add('isHidden');
            });
        },
        init: function (onCopy, onPaste, i18n) {
            if (STATUS.isInitialized) {
                return;
            }

            STATUS.isInitialized = true;

            let activeEl = null;
            let pressTimer = null;
            let menuOpenedByTouch = false;

            const menu = document.createElement('div');
            menu.className = 'chmContextMenu isHidden';

            const menuItems = [
                `<button data-clipboard-action="cut"><i class="fa-solid fa-scissors"></i> ${i18n.cut}</button>`,
                `<button data-clipboard-action="copy"><i class="fa-regular fa-copy"></i> ${i18n.copy}</button>`,
                `<button data-clipboard-action="paste"><i class="fa-solid fa-clipboard"></i> ${i18n.paste}</button>`
            ];

            menu.innerHTML = menuItems.join('');
            document.body.appendChild(menu);

            const cutBtn = menu.querySelector('[data-clipboard-action="cut"]');
            const copyBtn = menu.querySelector('[data-clipboard-action="copy"]');
            const pasteBtn = menu.querySelector('[data-clipboard-action="paste"]');

            document.addEventListener('contextmenu', function (e) {
                e.preventDefault();

                if (!menu.classList.contains('isHidden')) {
                    return;
                }

                const selection = window.getSelection();
                const selectedText = selection ? selection.toString().trim() : '';
                const target = e.target;

                if (!selectedText && !isEditable(target)) {
                    return;
                }

                if (pressTimer !== null) {
                    return;
                }

                activeEl = target;
                updateMenuVisibility(selectedText, isEditable(target));
                showMenuAt(e.clientX, e.clientY);
            });

            document.addEventListener('touchstart', function (e) {
                const target = e.target;

                if (target.closest('.chmContextMenu')) {
                    return;
                }

                hideMenu();

                pressTimer = setTimeout(function () {
                    const touch = e.touches[0];
                    const selection = window.getSelection();
                    const selectedText = selection ? selection.toString().trim() : '';

                    if (!selectedText && !isEditable(target)) {
                        pressTimer = null;
                        return;
                    }

                    activeEl = target;
                    menuOpenedByTouch = true;
                    updateMenuVisibility(selectedText, isEditable(target));
                    showMenuAt(touch.clientX, touch.clientY);

                    pressTimer = null;
                }, 500);
            });

            document.addEventListener('touchmove', function () {
                clearTimeout(pressTimer);
                pressTimer = null;
            });

            document.addEventListener('touchend', function () {
                clearTimeout(pressTimer);
                pressTimer = null;
            });

            document.addEventListener('click', function (e) {
                if (e.target.closest('.chmContextMenu')) {
                    return;
                }

                if (menuOpenedByTouch) {
                    menuOpenedByTouch = false;
                    return;
                }

                hideMenu();
            });

            menu.addEventListener('click', async function (e) {
                let button, action, start, end, selected, text;

                e.stopPropagation();

                button = e.target.closest('button');
                action = button ? button.dataset.clipboardAction : null;

                if (!action || !activeEl) {
                    hideMenu();
                    return;
                }

                if (typeof activeEl.focus === 'function') {
                    activeEl.focus();
                }

                if (isInputElement(activeEl)) {
                    start = activeEl.selectionStart;
                    end = activeEl.selectionEnd;
                    selected = activeEl.value.slice(start, end);
                } else {
                    selected = window.getSelection().toString();
                }

                if ((action === 'cut') && selected && isInputElement(activeEl)) {
                    onCopy(selected);
                    activeEl.setRangeText('', start, end, 'start');
                }

                if ((action === 'copy') && selected) {
                    onCopy(selected);
                }

                if ((action === 'paste') && isInputElement(activeEl)) {
                    try {
                        text = await onPaste();

                        if (text) {
                            activeEl.setRangeText(text, start, end, 'end');
                        }
                    } catch (error) {
                        console.warn('Clipboard read failed:', error);
                    }
                }

                hideMenu();
                activeEl = null;
            });

            function isEditable(el) {
                return el && ((el.tagName === 'INPUT') || (el.tagName === 'TEXTAREA')) && !el.readOnly && !el.disabled;
            }

            function isInputElement(el) {
                return el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA');
            }

            function showMenuAt(x, y) {
                menu.style.visibility = 'hidden';
                menu.classList.remove('isHidden');

                requestAnimationFrame(() => {
                    const rect = menu.getBoundingClientRect();
                    const menuHeight = rect.height;
                    const viewportHeight = window.innerHeight;

                    let top = y - menuHeight;

                    if (top < 10) {
                        top = y;
                        if (top + menuHeight > viewportHeight - 10) {
                            top = viewportHeight - menuHeight - 10;
                        }
                    }

                    menu.style.left = `${x}px`;
                    menu.style.top = `${top}px`;
                    menu.style.visibility = '';
                });
            }

            function hideMenu() {
                menu.classList.add('isHidden');
                menuOpenedByTouch = false;
            }

            function updateMenuVisibility(hasSelection, isEditable) {
                cutBtn.style.display = hasSelection && isEditable ? 'block' : 'none';
                copyBtn.style.display = hasSelection ? 'block' : 'none';
                pasteBtn.style.display = isEditable ? 'block' : 'none';
            }
        }
    };
})();
